import {
    createBaseThemeOptions,
    createUnifiedTheme,
    palettes,
  } from '@backstage/theme';
  
export const delavalTheme = createUnifiedTheme({
    ...createBaseThemeOptions({
        palette: {
            ...palettes.dark,
            type: 'dark',
            primary: {
                main: '#6494e0',
                light: '#4C9AFF',
                dark: '#2d528e',
            },
            secondary: {
                main: '#FF5630',
                light: '#FFAB00',
                dark: '#6554C0',
            },
            grey: {
                50: '#C1C7D0',
                100: '#7A869A',
                200: '#6B778C',
                300: '#5E6C84',
                400: '#505F79',
                500: '#42526E',
                600: '#344563',
                700: '#253858',
                800: '#172B4D',
                900: '#091E42',
            },
            error: {
                main: '#FF5630',
                light: '#FF8F73',
                dark: '#DE350B',
            },
            warning: {
                main: '#FFAB00',
                light: '#FFE380',
                dark: '#FF8B00',
            },
            success: {
                main: '#36B37E',
                light: '#79F2C0',
                dark: '#006644',
            },
            info: {
                main: '#0065FF',
                light: '#4C9AFF',
                dark: '#0747A6',
            },
            navigation: {
                ...palettes.dark.navigation,
                background: '#223046',
                color: '#FFFFFF',
                indicator: '#2684FF',
                navItem: {
                hoverBackground: 'rgba(116,118,121,0.6)',
                },
            },
            text: {
                primary: '#92B8F2',
            },
            background: {
                default: '#223046',
            },
            link: '#FFFFFF'
        },
    }),
    fontFamily: 'Roboto, sans-serif',
    defaultPageTheme: 'home',
    components: {
        BackstageHeader: {
            styleOverrides: {
            header: ({ theme }) => ({
                backgroundImage: 'unset',
                boxShadow: 'unset',
                paddingBottom: theme.spacing(1),
              }),
              title: ({ theme }) => ({
                color: theme.palette.primary.light,
                fontWeight: 900,
              }),
              subtitle: ({ theme }) => ({
                color: theme.palette.primary.light,
              }),
              type: ({ theme }) => ({
                color: theme.palette.primary.light,
              }),
            },
        },
        BackstageHeaderTabs: {
            styleOverrides: {
                defaultTab: {
                    fontSize: 'inherit',
                    textTransform: 'none',
                  },
                tabsWrapper: {
                    backgroundColor: '#0e1a2d'
                }
            },
        },
        BackstageOpenedDropdown: {
            styleOverrides: {
                icon: {
                    '& path': {
                      fill: '#FFFFFF',
                    },
                },
            },
        },
        BackstageTable: {
            styleOverrides: {
                root: {
                    '&> :first-child': {
                      borderBottom: '1px solid #D5D5D5',
                      boxShadow: 'none',
                    },
                    '& th': {
                      borderTop: 'none',
                      textTransform: 'none !important',
                    },
                  },
            },
        },
        CatalogReactUserListPicker: {
            styleOverrides: {
                title: {
                    textTransform: 'none',
                },
            },
        },
        MuiAlert: {
            styleOverrides: {
                root: {
                    borderRadius: 0,
                  },
                  standardError: ({theme}) => ({
                    color: '#FFFFFF',
                    backgroundColor: theme.palette.error.dark,
                    '& $icon': {
                      color: '#FFFFFF',
                    },
                  }),
                  standardInfo: ({theme}) => ({
                    color: '#FFFFFF',
                    backgroundColor: theme.palette.primary.dark,
                    '& $icon': {
                      color: '#FFFFFF',
                    },
                  }),
                  standardSuccess: ({theme}) => ({
                    color: '#FFFFFF',
                    backgroundColor: theme.palette.success.dark,
                    '& $icon': {
                      color: '#FFFFFF',
                    },
                  }),
                  standardWarning: ({theme}) => ({
                    color: theme.palette.grey[700],
                    backgroundColor: theme.palette.secondary.light,
                    '& $icon': {
                      color: theme.palette.grey[700],
                    },
                  }),
            },
        },
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    '&[aria-expanded=true]': {
                      backgroundColor: '#26385A',
                      color: '#FFFFFF',
                    },
                    '&[aria-expanded=true] path': {
                      fill: '#FFFFFF',
                    },
                  },
            }
        },
        MuiBackdrop: {
            styleOverrides: {
                root: {
                    backgroundColor: 'rgba(9,30,69,0.54)',
                  },
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 3,
                    textTransform: 'none',
                  },
                contained: {
                    boxShadow: 'none',
                },
            }
        },
        MuiChip: {
            styleOverrides: {
                root: ({theme}) => ({
                    borderRadius: 3,
                    backgroundColor: theme.palette.grey[500],
                    color: '#FFFFFF',
                    margin: 4,
                  }),
            }
        },
        MuiCardMedia: {
            styleOverrides: {
                root: {
                    backgroundImage: 'unset'
                }
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundColor: '#26385A'
                }
            }
        },
        MuiSelect: {
            styleOverrides: {
                root: {
                    '&[aria-expanded]': {
                      backgroundColor: '#26385A',
                      color: '#FFFFFF',
                    },
                  },
            }
        },
        MuiSwitch: {
            styleOverrides: {
                root: {
                    padding: 10,
                  },
                  switchBase: {
                    padding: 12,
                  },
                  thumb: {
                    backgroundColor: '#FFFFFF',
                    height: 14,
                    width: 14,
                  },
                  track: {
                    borderRadius: 9,
                  },
            }
        },
        MuiTableRow: {
            styleOverrides: {
                head: {
                    backgroundColor: '#FFFFFF'
                  }
            }
        },
        MuiTabs: {
            styleOverrides: {
                indicator: {
                    transition: 'none',
                  },
            }
        },
        MuiTypography: {
            styleOverrides: {
                button: {
                    textTransform: 'none',
                  },
            }
        }
    }
  });